var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
// Component
import ServiceButton from '../ServiceButton/ServiceButton';
// Assets
import './Tooltip.scss';
/**
 * Tooltip component
 */
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.closeListener = function (evt) {
            if (evt.target !== _this.element) {
                _this.props.onClickToggle();
            }
        };
        return _this;
    }
    /**
     * Component initialization
     */
    Tooltip.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            window.addEventListener('click', _this.closeListener);
        });
    };
    /**
     * Component destruction
     */
    Tooltip.prototype.componentWillUnmount = function () {
        window.removeEventListener('click', this.closeListener);
    };
    /**
     * Render component
     */
    Tooltip.prototype.render = function () {
        var _this = this;
        var services = this.props.services;
        return (React.createElement("div", { id: "tooltip", ref: function (element) {
                _this.element = element;
            } },
            React.createElement("div", { className: "container-service" }, services.map(function (service) { return (React.createElement(ServiceButton, __assign({ key: "service-" + service.slug }, { service: service }))); }))));
    };
    return Tooltip;
}(React.Component));
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map